import { apiRequest } from './api'

export function listCourtDiaryEntries() {
  return apiRequest('/court-diary/list', {
    method: 'POST',
  })
}

export function createCourtDiaryEntry(payload) {
  return apiRequest('/court-diary/create', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function updateCourtDiaryEntry(payload) {
  return apiRequest('/court-diary/update', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function deleteCourtDiaryEntry(courtDiaryId) {
  return apiRequest('/court-diary/delete', {
    method: 'POST',
    body: JSON.stringify({ courtDiaryId }),
  })
}
